import React from "react";
import { Link } from "react-router-dom";
import { APP_NAME } from "../utils/constants";

const Header = () => {
	return (
		<div className="w-full h-20 bg-white text-black flex items-center p-4 border-b-[1px]">
			<h1 className="text-orange-600 font-bold text-xl whitespace-nowrap mr-3 cursor-pointer">
				<Link to="/">&lt;/&gt; {APP_NAME}</Link>
			</h1>
			<div className="flex flex-nowrap justify-end w-full">
				<ul className=" flex-nowrap gap-3 font-normal items-center hidden lg:flex">
					<Link to="/">
						<li className="hover:font-medium text-center w-16 cursor-pointer ">
							<span className="w-fit px-[2px] relative before:content-[''] before:bg-orange-600  before:absolute before:bottom-[-3px] before:left-0 before:w-0 hover:before:w-full before:h-[2.5px] before:rounded-lg before:transition-all">
								Home
							</span>
						</li>
					</Link>
					<Link to="/courses">
						<li className="hover:font-medium text-center w-16 cursor-pointer">
							<span className="w-fit px-[2px] relative before:content-[''] before:bg-orange-600  before:absolute before:bottom-[-3px] before:left-0 before:w-0 hover:before:w-full before:h-[2.5px] before:rounded-lg before:transition-all">
								Courses
							</span>
						</li>
					</Link>
					<Link to="/tutorial">
						<li className="hover:font-medium text-center w-16 cursor-pointer">
							<span className="w-fit px-[2px] relative before:content-[''] before:bg-orange-600  before:absolute before:bottom-[-3px] before:left-0 before:w-0 hover:before:w-full before:h-[2.5px] before:rounded-lg before:transition-all">
								Tutorial
							</span>
						</li>
					</Link>
					<Link to="/blog">
						<li className="hover:font-medium text-center w-16 cursor-pointer">
							<span className="w-fit px-[2px] relative before:content-[''] before:bg-orange-600  before:absolute before:bottom-[-3px] before:left-0 before:w-0 hover:before:w-full before:h-[2.5px] before:rounded-lg before:transition-all">
								Blog
							</span>
						</li>
					</Link>
					<Link to="/notes">
						<li className="hover:font-medium text-center w-16 cursor-pointer">
							<span className="w-fit px-[2px] relative before:content-[''] before:bg-orange-600  before:absolute before:bottom-[-3px] before:left-0 before:w-0 hover:before:w-full before:h-[2.5px] before:rounded-lg before:transition-all">
								Notes
							</span>
						</li>
					</Link>
					<Link to="/contact">
						<li className="hover:font-medium text-center w-16 cursor-pointer">
							<span className="w-fit px-[2px] relative before:content-[''] before:bg-orange-600  before:absolute before:bottom-[-3px] before:left-0 before:w-0 hover:before:w-full before:h-[2.5px] before:rounded-lg before:transition-all">
								Contact
							</span>
						</li>
					</Link>
					<Link to="/work-with-us">
						<li className="hover:font-medium text-center w-32 cursor-pointer">
							<span className="w-fit px-[2px] relative before:content-[''] before:bg-orange-600  before:absolute before:bottom-[-3px] before:left-0 before:w-0 hover:before:w-full before:h-[2.5px] before:rounded-lg before:transition-all">
								Work With Us
							</span>
						</li>
					</Link>
				</ul>
				<div className="flex flex-nowrap gap-2 font-semibold ml-2">
					<Link to="/logIn">
						<button className="px-3 py-1 border rounded-lg text-white bg-orange-600 hidden lg:block">
							LogIn
						</button>
					</Link>
					<Link to="/signUp">
						<button className="px-3 py-1 border rounded-lg text-white bg-orange-600">
							SignUp
						</button>
					</Link>
				</div>
			</div>
		</div>
	);
};

export default Header;
